import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@mui/material';
import { Edit, Cancel, Save } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CpdLabeledValue from '@/components/ui/CpdLabeledValue';

const MoovAccountFboDialog = ({
  open,
  onClose,
  account,
  onSuccess,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [isFbo, setIsFbo] = useState(false);

  useEffect(() => {
    if (account) {
      setIsFbo(account.is_fbo || false);
    }
  }, [account, open]);

  const handleSave = () => {
    if (!account) return;
    onSuccess({ is_fbo: isFbo });
  };

  if (!account) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Edit color='primary' />
          {t('moov.fboDialog.title')}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CpdLabeledValue
            label={t('moov.fboDialog.accountName')}
            value={account.account_name}
          />

          <CpdLabeledValue
            label={t('moov.fboDialog.accountId')}
            value={account.account_id}
            valueVariant='body2'
            valueSx={{ wordBreak: 'break-all' }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isFbo}
                onChange={(e) => setIsFbo(e.target.checked)}
                disabled={loading}
              />
            }
            label={t('moov.fboDialog.fboLabel')}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} startIcon={<Cancel />} disabled={loading}>
          {t('moov.fboDialog.cancel')}
        </Button>
        <Button
          onClick={handleSave}
          variant='contained'
          startIcon={
            loading ? (
              <CircularProgress size={20} sx={{ color: 'white' }} />
            ) : (
              <Save sx={{ color: 'white' }} />
            )
          }
          disabled={loading}
          sx={{ color: 'white' }}>
          {t('moov.fboDialog.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoovAccountFboDialog;
